export default {
  communities: [],
  filters: {
    floorPlans: [],
    propertyTypes: [],
    schoolDistricts: [],
  },
};
